import styled from 'styled-components';


export const Wrapper = styled.div`
  .single-col {
    display: grid;
    grid-template-columns: 1fr;
  }

  .go-back {
    margin: 0 !important;
    position: absolute;
    cursor: pointer;
  }
`;

export const Content = styled.div`
  width: 85%;
  margin: 40px auto;
`;

export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin: 40px 0 65px;
  grid-column-gap: 4%;

  &.attempt-selector-row {
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      margin: 0 35px 0 0;
      font-size: 18px;
      font-weight: 700;
      color: white;
    }

    select {
      max-width: 270px;
      margin: 0;
    }
  }

  h1 {
    text-align: center;
    font-size: 30px;
    font-weight: 900;
    color: white;
    margin: 0;

    span {
      color: #ff0033;
    }
  }

  h5 {
    color: #3ee9f7;
    text-align: center;
    font-size: 26px;
    margin-top: 15px;
  }
  @media all and  (max-width: 1200px) {
    display: flex;
    flex-direction: column;
   }
`;

export const ContentCol = styled.div`
  display: grid;
  grid-row-gap: 40px;
  @media all and (max-width: 1200px) {
    display: flex;
    flex-direction: column;
    margin-bottom: 2em;
   }
`;

export const LessonSelector = styled.div`
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin: 0 auto;

  p, select {
    margin: 0;
  }

  select {
    ${'' /* margin: 0 0 0 40px; */}
    margin: 100px 0 100px 40px;
    width: 250px;
  }
  @media all and (max-width: 1200px) {
    select {
      width: 400px;
    }
   }
`;

export const PickerHeader = styled.h1`
  width: 100%;
  text-align: center;color: #fff; font: italic bold 20px 'Roboto Condensed';
`



// WEBPACK FOOTER //
// ./src/pages/DataCenter/CourseDetails/CourseDetails.styles.ts